import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row align-items-center flex-nowrap" }
const _hoisted_2 = { style: {"width":"50px"} }
const _hoisted_3 = {
  key: 0,
  class: "m-0 text-white"
}
const _hoisted_4 = {
  class: "notification-text mr-3",
  style: {"flex":"1"}
}
const _hoisted_5 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_6 = { class: "mb-0 text-sm text-white" }
const _hoisted_7 = { class: "text-sm mb-0" }
const _hoisted_8 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_9 = {
  key: 0,
  type: "button",
  class: "close small text-light",
  "data-dismiss": "modal",
  "aria-label": "Descargar"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "×", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "container" }
const _hoisted_15 = { class: "row justify-content-center" }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]

import { computed, onMounted } from "vue";
import { DateTime } from "ts-luxon";
import { getInitials } from "@/util/utils";
import { TicketModule } from "@/store/modules/Ticket";
import {
	isImageFile,
	isVideoFile,
} from "vue-advanced-chat/src/utils/media-file.js";
// Types
import { Message, MessageFile } from "vue-advanced-chat";
import { ModalSidebarState as ModalState } from "@/types/components";
// Components
import Modal from "@/components/Modal.vue";
// import Loader from "vue-advanced-chat/src/components/Loader/Loader.vue";

// props

export default /*#__PURE__*/_defineComponent({
  props: {
    open: { type: Boolean },
    message: null,
    file: null
  },
  emits: ["changeModal"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: "changeModal", t: ModalState): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { open: boolean; message?: Message; file?: MessageFile }

// General

// emits

//state
/* const imageResponsive = ref("");
const imageLoading = ref(false);
const imageHover = ref(false); */
// computed
const file = computed<MessageFile | undefined>(
	() => props.file ?? props.message?.files?.[0]
);
const room = computed(() => TicketModule.currentRoom);
const isImage = computed(() => isImageFile(file.value));
const isVideo = computed(() => isVideoFile(file.value));

// Methods
function getTime(time: string) {
	return DateTime.fromISO(time).toRelative();
}
onMounted(() => {
	const modalBody = document.getElementsByClassName("modal-preview--body")[0];
	modalBody.addEventListener(
		"click",
		() => {
			emits("changeModal", { show: false });
		},
		{ once: false }
	);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    show: props.open,
    "fade-classes": "modal-preview--fade modal-primary",
    "modal-classes": "w-100 h-100 mw-100 p-3 m-0 d-flex align-items-stretch modal-preview",
    type: "notice",
    onClose: _cache[3] || (_cache[3] = ($event: any) => (emits('changeModal', { show: false }))),
    "body-classes": "modal-preview--body py-0 d-flex align-items-center justify-content-center",
    style: {"animation-duration":"0.3s"},
    "header-classes": "modal-preview--header align-items-center",
    "modal-content-classes": "modal-preview--content text-white"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "vac-avatar d-flex align-items-center justify-content-center",
            style: _normalizeStyle({
							background: _unref(room)?.avatar ? `url('${_unref(room)?.avatar}')` : _unref(room)?.color,
							backgroundSize: 'cover',
							backgroundPosition: 'center center',
						})
          }, [
            (!_unref(room)?.avatar)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_3, _toDisplayString(_unref(getInitials)(_unref(room)?.roomName ?? "", _unref(room)?.users[0].username)), 1))
              : _createCommentVNode("", true)
          ], 4)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h4", _hoisted_6, _toDisplayString(_unref(room)?.roomName), 1)
          ]),
          _createElementVNode("p", _hoisted_7, _toDisplayString(getTime(_unref(room)?.lastMessageDate ?? "")), 1)
        ])
      ])
    ]),
    "close-button": _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        (!(_unref(isImage) || _unref(isVideo)))
          ? (_openBlock(), _createElementBlock("button", _hoisted_9, _hoisted_11))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('changeModal', { show: false }))),
          "data-dismiss": "modal",
          "aria-label": "Cerrar"
        }, _hoisted_13)
      ])
    ]),
    footer: _withCtx(() => []),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          (_unref(isImage))
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "img-preview",
                src: _unref(file)?.url || '',
                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
              }, null, 8, _hoisted_16))
            : (_unref(isVideo))
              ? (_openBlock(), _createElementBlock("video", {
                  key: 1,
                  class: "img-preview",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                  controls: ""
                }, [
                  _createElementVNode("source", {
                    src: _unref(file)?.url
                  }, null, 8, _hoisted_17)
                ]))
              : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})